export default __webpack_public_path__ + "static/media/115_mobile.2de389b4.jpg";